let cachedConfig = null;

export const getProductConfigurator = () => {
  if (cachedConfig === null) {
    const elem = document.querySelector('#configurator-root');
    cachedConfig = {
        product: elem.dataset.product,
        fieldsJsonURL: elem.dataset.fields,
        jsonURL: elem.dataset.json
    };
  }
  return cachedConfig;
};

// Export the var directly (auto-caches on access)
export const productConfigurator = getProductConfigurator();



